import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '../audi-ui-components/Button';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import * as ACTIONS_CREATOR from '../redux/ShoppingCartActionsCreator';
import * as CONST from '../constants';

const mapStateToProps = (state) => {
    return {
        cart: state.shoppingCart.finalCart,
        disableNav: state.shoppingCart.disableNav,
        donation: state.shoppingCart.donation,
        donationError: state.shoppingCart.donationError
    };
};

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        disableNavItems: ACTIONS_CREATOR.disableNavItems,
    },
    dispatch,
);

class ConfirmationForm extends Component {
    componentDidMount() {
        this.props.disableNavItems(this.props.disableNav, CONST.CONFIRMATION_NAV_INDEX, false);
        if (dataLayer) {
            const {cart} = this.props;
            var hasExperienceBooking = false;
            var hasCertificateOnline = false;
            for (let i=0; i<cart.items.length; i++) {
                if (cart.items[i].type === "ExperienceBooking") {
                    hasExperienceBooking = true;
                }
                if (cart.items[i].type === "GiftCard") {
                    hasCertificateOnline = true;
                }
            };
            dataLayer.push({
                'event': 'checkoutConfirmation',
                'hasExperienceBooking': hasExperienceBooking,
                'hasCertificateOnline': hasCertificateOnline,
                'amount': cart.amount,
                'orderNumber': cart.id
            });
        }
    }

    render() {
        const {cart, donation} = this.props;
        var hasExperienceBooking = false;
        for (let i=0; i<cart.items.length; i++) {
            if (cart.items[i].type === "ExperienceBooking") {
                hasExperienceBooking = true;
                break;
            }
        };
        var formattedDob = "";
        if (cart.customer && cart.customer.birthDate) {
            formattedDob = moment(cart.customer.birthDate).format("D MMMM YYYY");
        }
        return (
            <section className="mb-4">
                <header>
                    <h2 className="aui-headline-3 mb-4">Your booking summary</h2>
                    <p>Your order confirmation number is <strong>{cart.id}</strong></p>
                </header>
                <div className="mt-4">
                  <Button variant="primary" href={`${process.env.RAZZLE_ADE_API}/1/order/invoice/${cart.id}`} rel="noreferrer" target="_blank">Download Invoice</Button>
                </div>
                {cart.customer && <div className="mt-4 d-flex flex-column">
                    <div>{cart.customer.firstName} {cart.customer.lastName}</div>
                    <div className="row">
                        <div className="col-12 col-sm">Email: {cart.customer.email}</div>
                        <div className="col-12 col-sm">Contact number: {cart.customer.mobile}</div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm">Postcode: {cart.customer.postcode}</div>
                        <div className="col-12 col-sm">DOB: {formattedDob}</div>
                    </div>
                    {hasExperienceBooking && <div>
                        {cart.customer.licenseNumber && <div className="my-4">Driver's licence: {cart.customer.licenseNumber} ({cart.customer.licenseState})</div>}
                        <div>Dietary requirements: {cart.customer.hasSpecialDiet ? <span>Yes</span> : <span>No</span>}</div>
                        {cart.customer.hasSpecialDiet && <div>Notes: {cart.customer.specialDietNote}</div>}
                    </div>}
                </div>}
                {donation && donation > 0 && <div className="mt-4">
                    {this.props.donationError && <p className="aui-color-text-red">There was a problem processing your donation. If you would still like to donate, please visit <a href="https://audifoundation.com.au/donate" target="_blank" rel="noreferrer" className="aui-textlink">Audi Foundation</a></p>}
                    {!this.props.donationError && <p className="">Your donation of ${donation} to Audi Foundation was successful.</p>}
                </div>}
            </section>
         );
    }
}

ConfirmationForm.propTypes = {
    disableNav: PropTypes.array,
    disableNavItems: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationForm);
